import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Directive, Output, HostListener, forwardRef, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = a0 => ({
  "dropdown-multiselect--active": a0
});
function MultiSelectComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0._placeholder);
  }
}
function MultiSelectComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15)(1, "span", 16)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 17);
    i0.ɵɵlistener("click", function MultiSelectComponent_span_4_Template_a_click_4_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onItemClick($event, item_r3));
    });
    i0.ɵɵtext(5, "x");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const k_r4 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", k_r4 > ctx_r0._settings.itemsShowLimit - 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", item_r3.text, "\xA0");
  }
}
function MultiSelectComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", ctx_r0.itemShowRemaining(), "");
  }
}
function MultiSelectComponent_li_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19);
    i0.ɵɵlistener("click", function MultiSelectComponent_li_10_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleSelectAll());
    });
    i0.ɵɵelement(1, "input", 20);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.isAllItemsSelected())("disabled", ctx_r0.disabled || ctx_r0.isLimitSelectionReached());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(!ctx_r0.isAllItemsSelected() ? ctx_r0._settings.selectAllText : ctx_r0._settings.unSelectAllText);
  }
}
function MultiSelectComponent_li_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 21)(1, "input", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function MultiSelectComponent_li_11_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.filter.text, $event) || (ctx_r0.filter.text = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function MultiSelectComponent_li_11_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onFilterTextChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("readOnly", ctx_r0.disabled)("placeholder", ctx_r0._settings.searchPlaceholderText);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.filter.text);
  }
}
function MultiSelectComponent_li_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 23);
    i0.ɵɵlistener("click", function MultiSelectComponent_li_13_Template_li_click_0_listener($event) {
      const item_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onItemClick($event, item_r8));
    });
    i0.ɵɵelement(1, "input", 24);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r0.isSelected(item_r8))("disabled", ctx_r0.disabled || ctx_r0.isLimitSelectionReached() && !ctx_r0.isSelected(item_r8) || item_r8.isDisabled);
    i0.ɵɵattribute("aria-label", item_r8.text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r8.text);
  }
}
function MultiSelectComponent_li_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 25)(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0._settings.noFilteredDataAvailablePlaceholderText);
  }
}
function MultiSelectComponent_li_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 26)(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0._settings.noDataAvailablePlaceholderText);
  }
}
class ListItem {
  id;
  text;
  isDisabled;
  constructor(source) {
    if (typeof source === 'string' || typeof source === 'number') {
      this.id = this.text = source;
      this.isDisabled = false;
    }
    if (typeof source === 'object') {
      this.id = source.id;
      this.text = source.text;
      this.isDisabled = source.isDisabled;
    }
  }
}
let ListFilterPipe = /*#__PURE__*/(() => {
  class ListFilterPipe {
    transform(items, filter) {
      if (!items || !filter) {
        return items;
      }
      return items.filter(item => this.applyFilter(item, filter));
    }
    applyFilter(item, filter) {
      if (typeof item.text === 'string' && typeof filter.text === 'string') {
        return !(filter.text && item.text && item.text.toLowerCase().indexOf(filter.text.toLowerCase()) === -1);
      } else {
        return !(filter.text && item.text && item.text.toString().toLowerCase().indexOf(filter.text.toString().toLowerCase()) === -1);
      }
    }
    static ɵfac = function ListFilterPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListFilterPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "multiSelectFilter",
      type: ListFilterPipe,
      pure: false,
      standalone: false
    });
  }
  return ListFilterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClickOutsideDirective = /*#__PURE__*/(() => {
  class ClickOutsideDirective {
    _elementRef;
    constructor(_elementRef) {
      this._elementRef = _elementRef;
    }
    clickOutside = new EventEmitter();
    onClick(event, targetElement) {
      if (!targetElement) {
        return;
      }
      const clickedInside = this._elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.clickOutside.emit(event);
      }
    }
    static ɵfac = function ClickOutsideDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ClickOutsideDirective,
      selectors: [["", "clickOutside", ""]],
      hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event, $event.target);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      outputs: {
        clickOutside: "clickOutside"
      },
      standalone: false
    });
  }
  return ClickOutsideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DROPDOWN_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectComponent),
  multi: true
};
const noop = () => {};
let MultiSelectComponent = /*#__PURE__*/(() => {
  class MultiSelectComponent {
    listFilterPipe;
    cdr;
    _settings;
    _data = [];
    selectedItems = [];
    isDropdownOpen = true;
    _placeholder = "Select";
    _sourceDataType = null; // to keep note of the source data type. could be array of string/number/object
    _sourceDataFields = []; // store source data fields names
    filter = new ListItem(this.data);
    defaultSettings = {
      singleSelection: false,
      idField: "id",
      textField: "text",
      disabledField: "isDisabled",
      enableCheckAll: true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 999999999999,
      searchPlaceholderText: "Search",
      noDataAvailablePlaceholderText: "No data available",
      noFilteredDataAvailablePlaceholderText: "No filtered data available",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
      allowRemoteDataSearch: false
    };
    set placeholder(value) {
      if (value) {
        this._placeholder = value;
      } else {
        this._placeholder = "Select";
      }
    }
    disabled = false;
    set settings(value) {
      if (value) {
        this._settings = Object.assign(this.defaultSettings, value);
      } else {
        this._settings = Object.assign(this.defaultSettings);
      }
    }
    set data(value) {
      if (!value) {
        this._data = [];
      } else {
        const firstItem = value[0];
        this._sourceDataType = typeof firstItem;
        this._sourceDataFields = this.getFields(firstItem);
        this._data = value.map(item => typeof item === "string" || typeof item === "number" ? new ListItem(item) : new ListItem({
          id: item[this._settings.idField],
          text: item[this._settings.textField],
          isDisabled: item[this._settings.disabledField]
        }));
      }
    }
    onFilterChange = new EventEmitter();
    onDropDownClose = new EventEmitter();
    onSelect = new EventEmitter();
    onDeSelect = new EventEmitter();
    onSelectAll = new EventEmitter();
    onDeSelectAll = new EventEmitter();
    onTouchedCallback = noop;
    onChangeCallback = noop;
    onFilterTextChange($event) {
      this.onFilterChange.emit($event);
    }
    constructor(listFilterPipe, cdr) {
      this.listFilterPipe = listFilterPipe;
      this.cdr = cdr;
    }
    onItemClick($event, item) {
      if (this.disabled || item.isDisabled) {
        return false;
      }
      const found = this.isSelected(item);
      const allowAdd = this._settings.limitSelection === -1 || this._settings.limitSelection > 0 && this.selectedItems.length < this._settings.limitSelection;
      if (!found) {
        if (allowAdd) {
          this.addSelected(item);
        }
      } else {
        this.removeSelected(item);
      }
      if (this._settings.singleSelection && this._settings.closeDropDownOnSelection) {
        this.closeDropdown();
      }
    }
    writeValue(value) {
      if (value !== undefined && value !== null && value.length > 0) {
        if (this._settings.singleSelection) {
          try {
            if (value.length >= 1) {
              const firstItem = value[0];
              this.selectedItems = [typeof firstItem === "string" || typeof firstItem === "number" ? new ListItem(firstItem) : new ListItem({
                id: firstItem[this._settings.idField],
                text: firstItem[this._settings.textField],
                isDisabled: firstItem[this._settings.disabledField]
              })];
            }
          } catch (e) {
            // console.error(e.body.msg);
          }
        } else {
          const _data = value.map(item => typeof item === "string" || typeof item === "number" ? new ListItem(item) : new ListItem({
            id: item[this._settings.idField],
            text: item[this._settings.textField],
            isDisabled: item[this._settings.disabledField]
          }));
          if (this._settings.limitSelection > 0) {
            this.selectedItems = _data.splice(0, this._settings.limitSelection);
          } else {
            this.selectedItems = _data;
          }
        }
      } else {
        this.selectedItems = [];
      }
      this.onChangeCallback(value);
      this.cdr.markForCheck();
    }
    // From ControlValueAccessor interface
    registerOnChange(fn) {
      this.onChangeCallback = fn;
    }
    // From ControlValueAccessor interface
    registerOnTouched(fn) {
      this.onTouchedCallback = fn;
    }
    // Set touched on blur
    onTouched() {
      // this.closeDropdown();
      this.onTouchedCallback();
    }
    trackByFn(index, item) {
      return item.id;
    }
    isSelected(clickedItem) {
      let found = false;
      this.selectedItems.forEach(item => {
        if (clickedItem.id === item.id) {
          found = true;
        }
      });
      return found;
    }
    isLimitSelectionReached() {
      return this._settings.limitSelection === this.selectedItems.length;
    }
    isAllItemsSelected() {
      // get disabld item count
      let filteredItems = this.listFilterPipe.transform(this._data, this.filter);
      const itemDisabledCount = filteredItems.filter(item => item.isDisabled).length;
      // take disabled items into consideration when checking
      if ((!this.data || this.data.length === 0) && this._settings.allowRemoteDataSearch) {
        return false;
      }
      return filteredItems.length === this.selectedItems.length + itemDisabledCount;
    }
    showButton() {
      if (!this._settings.singleSelection) {
        if (this._settings.limitSelection > 0) {
          return false;
        }
        // this._settings.enableCheckAll = this._settings.limitSelection === -1 ? true : false;
        return true; // !this._settings.singleSelection && this._settings.enableCheckAll && this._data.length > 0;
      } else {
        // should be disabled in single selection mode
        return false;
      }
    }
    itemShowRemaining() {
      return this.selectedItems.length - this._settings.itemsShowLimit;
    }
    addSelected(item) {
      if (this._settings.singleSelection) {
        this.selectedItems = [];
        this.selectedItems.push(item);
      } else {
        this.selectedItems.push(item);
      }
      this.onChangeCallback(this.emittedValue(this.selectedItems));
      this.onSelect.emit(this.emittedValue(item));
    }
    removeSelected(itemSel) {
      this.selectedItems.forEach(item => {
        if (itemSel.id === item.id) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
        }
      });
      this.onChangeCallback(this.emittedValue(this.selectedItems));
      this.onDeSelect.emit(this.emittedValue(itemSel));
    }
    emittedValue(val) {
      const selected = [];
      if (Array.isArray(val)) {
        val.map(item => {
          selected.push(this.objectify(item));
        });
      } else {
        if (val) {
          return this.objectify(val);
        }
      }
      return selected;
    }
    objectify(val) {
      if (this._sourceDataType === 'object') {
        const obj = {};
        obj[this._settings.idField] = val.id;
        obj[this._settings.textField] = val.text;
        if (this._sourceDataFields.includes(this._settings.disabledField)) {
          obj[this._settings.disabledField] = val.isDisabled;
        }
        return obj;
      }
      if (this._sourceDataType === 'number') {
        return Number(val.id);
      } else {
        return val.text;
      }
    }
    toggleDropdown(evt) {
      evt.preventDefault();
      if (this.disabled && this._settings.singleSelection) {
        return;
      }
      this._settings.defaultOpen = !this._settings.defaultOpen;
      if (!this._settings.defaultOpen) {
        this.onDropDownClose.emit();
      }
    }
    closeDropdown() {
      this._settings.defaultOpen = false;
      // clear search text
      if (this._settings.clearSearchFilter) {
        this.filter.text = "";
      }
      this.onDropDownClose.emit();
    }
    toggleSelectAll() {
      if (this.disabled) {
        return false;
      }
      if (!this.isAllItemsSelected()) {
        // filter out disabled item first before slicing
        this.selectedItems = this.listFilterPipe.transform(this._data, this.filter).filter(item => !item.isDisabled).slice();
        this.onSelectAll.emit(this.emittedValue(this.selectedItems));
      } else {
        this.selectedItems = [];
        this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
      }
      this.onChangeCallback(this.emittedValue(this.selectedItems));
    }
    getFields(inputData) {
      const fields = [];
      if (typeof inputData !== "object") {
        return fields;
      }
      // tslint:disable-next-line:forin
      for (const prop in inputData) {
        fields.push(prop);
      }
      return fields;
    }
    static ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiSelectComponent)(i0.ɵɵdirectiveInject(ListFilterPipe), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiSelectComponent,
      selectors: [["ng-multiselect-dropdown"]],
      hostBindings: function MultiSelectComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("blur", function MultiSelectComponent_blur_HostBindingHandler() {
            return ctx.onTouched();
          });
        }
      },
      inputs: {
        placeholder: "placeholder",
        disabled: "disabled",
        settings: "settings",
        data: "data"
      },
      outputs: {
        onFilterChange: "onFilterChange",
        onDropDownClose: "onDropDownClose",
        onSelect: "onSelect",
        onDeSelect: "onDeSelect",
        onSelectAll: "onSelectAll",
        onDeSelectAll: "onDeSelectAll"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DROPDOWN_CONTROL_VALUE_ACCESSOR])],
      decls: 18,
      vars: 23,
      consts: [["tabindex", "0", 1, "multiselect-dropdown", 3, "blur", "clickOutside"], ["tabindex", "-1", 1, "dropdown-btn", 3, "click"], [4, "ngIf"], ["class", "selected-item-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [2, "float", "right !important", "padding-right", "4px", 3, "ngClass"], ["style", "padding-right: 15px;", 4, "ngIf"], [1, "dropdown-multiselect__caret"], [1, "dropdown-list", 3, "hidden"], [1, "item1"], ["class", "multiselect-item-checkbox", "style", "border-bottom: 1px solid #ccc;padding:10px", 3, "click", 4, "ngIf"], ["class", "filter-textbox", 4, "ngIf"], [1, "item2"], ["class", "multiselect-item-checkbox", 3, "click", 4, "ngFor", "ngForOf"], ["class", "no-filtered-data", 4, "ngIf"], ["class", "no-data", 4, "ngIf"], [1, "selected-item-container"], [1, "selected-item", 3, "hidden"], [2, "padding-left", "2px", "color", "white", 3, "click"], [2, "padding-right", "15px"], [1, "multiselect-item-checkbox", 2, "border-bottom", "1px solid #ccc", "padding", "10px", 3, "click"], ["type", "checkbox", "aria-label", "multiselect-select-all", 3, "checked", "disabled"], [1, "filter-textbox"], ["type", "text", "aria-label", "multiselect-search", 3, "ngModelChange", "readOnly", "placeholder", "ngModel"], [1, "multiselect-item-checkbox", 3, "click"], ["type", "checkbox", 3, "checked", "disabled"], [1, "no-filtered-data"], [1, "no-data"]],
      template: function MultiSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("blur", function MultiSelectComponent_Template_div_blur_0_listener() {
            return ctx.onTouched();
          })("clickOutside", function MultiSelectComponent_Template_div_clickOutside_0_listener() {
            return ctx.closeDropdown();
          });
          i0.ɵɵelementStart(1, "div")(2, "span", 1);
          i0.ɵɵlistener("click", function MultiSelectComponent_Template_span_click_2_listener($event) {
            return ctx.toggleDropdown($event);
          });
          i0.ɵɵtemplate(3, MultiSelectComponent_span_3_Template, 2, 1, "span", 2)(4, MultiSelectComponent_span_4_Template, 6, 2, "span", 3);
          i0.ɵɵelementStart(5, "span", 4);
          i0.ɵɵtemplate(6, MultiSelectComponent_span_6_Template, 2, 1, "span", 5);
          i0.ɵɵelement(7, "span", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(8, "div", 7)(9, "ul", 8);
          i0.ɵɵtemplate(10, MultiSelectComponent_li_10_Template, 4, 3, "li", 9)(11, MultiSelectComponent_li_11_Template, 2, 3, "li", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "ul", 11);
          i0.ɵɵtemplate(13, MultiSelectComponent_li_13_Template, 4, 4, "li", 12);
          i0.ɵɵpipe(14, "multiSelectFilter");
          i0.ɵɵtemplate(15, MultiSelectComponent_li_15_Template, 3, 1, "li", 13);
          i0.ɵɵpipe(16, "multiSelectFilter");
          i0.ɵɵtemplate(17, MultiSelectComponent_li_17_Template, 3, 1, "li", 14);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.selectedItems.length == 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.selectedItems)("ngForTrackBy", ctx.trackByFn);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c0, ctx._settings.defaultOpen));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.itemShowRemaining() > 0);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("hidden", !ctx._settings.defaultOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (ctx._data.length > 0 || ctx._settings.allowRemoteDataSearch) && !ctx._settings.singleSelection && ctx._settings.enableCheckAll && ctx._settings.limitSelection === -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx._data.length > 0 || ctx._settings.allowRemoteDataSearch) && ctx._settings.allowSearchFilter);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("max-height", ctx._settings.maxHeight + "px");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(14, 15, ctx._data, ctx.filter));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx._data.length != 0 && i0.ɵɵpipeBind2(16, 18, ctx._data, ctx.filter).length == 0 && !ctx._settings.allowRemoteDataSearch);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx._data.length == 0 && !ctx._settings.allowRemoteDataSearch);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, ClickOutsideDirective, ListFilterPipe],
      styles: [".multiselect-dropdown[_ngcontent-%COMP%]{position:relative;width:100%;font-size:inherit;font-family:inherit}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]{display:inline-block;border:1px solid #adadad;width:100%;padding:6px 12px;margin-bottom:0;font-weight:400;line-height:1.52857143;text-align:left;vertical-align:middle;cursor:pointer;background-image:none;border-radius:4px}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-container[_ngcontent-%COMP%]{display:flex;float:left}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-container[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]{border:1px solid #337ab7;margin-right:4px;background:#337ab7;padding:0 5px;color:#fff;border-radius:2px;float:left;max-width:100px}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-container[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-container[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]:hover{box-shadow:1px 1px #959595}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .dropdown-multiselect__caret[_ngcontent-%COMP%]{line-height:16px;display:block;position:absolute;box-sizing:border-box;width:40px;height:38px;right:1px;top:0;padding:4px 8px;margin:0;text-decoration:none;text-align:center;cursor:pointer;transition:transform .2s ease}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .dropdown-multiselect__caret[_ngcontent-%COMP%]:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-style:solid;border-width:8px 8px 0 8px;border-color:#999999 transparent;content:\"\"}.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .dropdown-multiselect--active[_ngcontent-%COMP%]   .dropdown-multiselect__caret[_ngcontent-%COMP%]{transform:rotate(180deg)}.multiselect-dropdown[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{background-color:#eceeef}.dropdown-list[_ngcontent-%COMP%]{position:absolute;padding-top:6px;width:100%;z-index:9999;border:1px solid #ccc;border-radius:3px;background:#fff;margin-top:10px;box-shadow:0 1px 5px #959595}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;list-style:none;overflow:auto;margin:0}.dropdown-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:6px 10px;cursor:pointer;text-align:left}.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]{border-bottom:1px solid #ccc;position:relative;padding:10px}.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:0px;width:100%;padding:0 0 0 26px}.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}.multiselect-item-checkbox[_ngcontent-%COMP%]:hover{background-color:#e4e3e3}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:focus + div[_ngcontent-%COMP%]:before, .multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:hover + div[_ngcontent-%COMP%]:before{border-color:#337ab7;background-color:#f2f2f2}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:active + div[_ngcontent-%COMP%]:before{transition-duration:0s}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{position:relative;padding-left:2em;vertical-align:middle;-webkit-user-select:none;user-select:none;cursor:pointer;margin:0;color:#000}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] + div[_ngcontent-%COMP%]:before{box-sizing:content-box;content:\"\";color:#337ab7;position:absolute;top:50%;left:0;width:14px;height:14px;margin-top:-9px;border:2px solid #337ab7;text-align:center;transition:all .4s ease}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] + div[_ngcontent-%COMP%]:after{box-sizing:content-box;content:\"\";background-color:#337ab7;position:absolute;top:50%;left:4px;width:10px;height:10px;margin-top:-5px;transform:scale(0);transform-origin:50%;transition:transform .2s ease-out}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:disabled + div[_ngcontent-%COMP%]:before{border-color:#ccc}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:disabled:focus + div[_ngcontent-%COMP%]:before   .multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:disabled:hover + div[_ngcontent-%COMP%]:before{background-color:inherit}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:disabled:checked + div[_ngcontent-%COMP%]:before{background-color:#ccc}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] + div[_ngcontent-%COMP%]:after{background-color:transparent;top:50%;left:4px;width:8px;height:3px;margin-top:-4px;border-style:solid;border-color:#fff;border-width:0 0 3px 3px;border-image:none;transform:rotate(-45deg) scale(0)}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + div[_ngcontent-%COMP%]:after{content:\"\";transform:rotate(-45deg) scale(1);transition:transform .2s ease-out}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + div[_ngcontent-%COMP%]:before{animation:_ngcontent-%COMP%_borderscale .2s ease-in;background:#337ab7}.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked + div[_ngcontent-%COMP%]:after{transform:rotate(-45deg) scale(1)}@keyframes _ngcontent-%COMP%_borderscale{50%{box-shadow:0 0 0 2px #337ab7}}"],
      changeDetection: 0
    });
  }
  return MultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgMultiSelectDropDownModule = /*#__PURE__*/(() => {
  class NgMultiSelectDropDownModule {
    static forRoot() {
      return {
        ngModule: NgMultiSelectDropDownModule
      };
    }
    static ɵfac = function NgMultiSelectDropDownModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgMultiSelectDropDownModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgMultiSelectDropDownModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ListFilterPipe],
      imports: [CommonModule, FormsModule]
    });
  }
  return NgMultiSelectDropDownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MultiSelectComponent, NgMultiSelectDropDownModule };
